/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
import { HttpClient } from '@angular/common/http';
import { Injectable, Input, Inject } from '@angular/core';
import { clone } from 'lodash-es';

/**
 * Service to handle the fetching and retention of Family Member activities.
 */
@Injectable()
export class FamilyMemberService {
  protected debug: boolean = false;

  public storedAccount: any;

  public account: any;

  public newActivitiesExist: boolean = false;

  constructor(
    private http: HttpClient,
    @Inject('$state') private $state,
    @Inject('$anchorScroll') private $anchorScroll,
    @Inject('$location') private $location,
    @Inject('BulbAuthService') private BulbAuthService,
  ) {}

  fetchStudentActivities(memberId, studentId?, lastId?): Promise<any> {
    const params = {
      pageSize: '5',
      filter: studentId || '',
      lastId: lastId || '',
    };
    return this.http.get(`accounts/${memberId}/studentActivities`, { params }).toPromise();
  }

  scrollToAnchor(id): void {
    this.$state.go('account.settings').then(() => {
      this.$location.hash(id);
      this.$anchorScroll();
    });
  }

  refreshAccount() {
    this.BulbAuthService.fetchCurrentUser()
      .then((response) => {
        this.storedAccount = response;
        this.account = clone(response);
      });
  }

  setNewActivitiesToTrue(activitiesArr) {
    activitiesArr.forEach((activity) => {
      if (activity.isNew) {
        this.newActivitiesExist = true;
      }
    });
  }

  setNewToFalse(parentId, activityId): Promise<any> {
    return this.http.patch(`accounts/${parentId}/studentActivities/${activityId}/notNew`, {}).toPromise();
  }
}
